import CurrencyInput from "../Currency/CurrencyInput";
// import CurrencySpan from "../Currency/CurrencySpan";
// import Queries from "../../queries/queries2";
import React from "react";
import Table from "../../elements/Table/Table";
import { compose } from "react-apollo";
// import _ from "lodash-es";
// import _ from "lodash-es";
import { injectIntl } from "react-intl";
import moment from "moment";
import toBottomRound from "../../assets/img/to_bottom_round.png";

import currencyText from "../Currency/currencyText";

class BudgetItemFormTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
      items: [],

      idsCopyRight: props.intl.formatMessage({
        id: "ids_copyRight"
      }),

      idsCopyDown: props.intl.formatMessage({
        id: "ids_copyDown"
      }),

      idsPropagateToBottom: props.intl.formatMessage({
        id: "ids_propagateToBottom"
      })
    };
  }

  static buildYearArray = (items, year) => {
    const filledData = [];

    // const sorted = _.orderBy(items, ["year", "month"]);
    // console.table("sorted", sorted);

    for (let y = year; y <= year + 1; y++) {
      for (let month = 1; month <= 12; month++) {
        // lookup month in data array
        let amount = 0;
        let realValue = 0;
        let dateSaisie = null;
        let tiersCollaborator = null;
        // let isReal = true;

        // trick to reorder items
        for (const d of items) {
          if (d.month === month && d.year === y) {
            amount = d.amount;
            realValue = d.realValue;

            dateSaisie = d.dateSaisie;
            tiersCollaborator = d.tiersCollaborator;
            // isReal = d.isReal;
          }
        }

        // expects locale() has NOT been called !!!
        filledData.push({
          amount,
          month,
          monthText: `${y}/${moment(`${month}/01/2000`).format("MM")}`,
          // monthText: `${y} ${moment(`${month}/01/2000`).format("MMMM")}`,
          year: y,
          realValue,
          dateSaisie,
          tiersCollaborator,
          // isReal
        });
      }
    }
    return filledData;
  };

  static getDerivedStateFromProps = async (props, state) => {
    // console.log("79 - getDerivedStateFromProps", props, state);

    if (props.data && state.id !== props.data.id) {
      const filledData = BudgetItemFormTable.buildYearArray(
        props.data.items,
        props.year,
        props.currencyId
      );
      state.id = props.data.id;
      state.items = filledData;

      // console.log("91 - updateBudgetIsReal", props.data.items);
      props.updateBudgetItemTable(state.items);

      if (props.data.items) {
        const year = props.year;
        // console.log("97 - year=", year);

        let found = 0;
        let index = 0;
        while (index < props.data.items.length && found === 0) {
          const item = props.data.items[index];

          if (item.year === year || item.year === year + 1) {
            found = 1
            props.updateBudgetIsReal(item.budgetIsReal, item.budgetIsReal);
          }
          else
            index++;
        }

        if (props.data.items.length === 0) {  // no item => isReal is true by default

          // console.log("114 - props=", props);
          if (props.globalIsReal !== undefined)
            props.updateBudgetIsReal(props.globalIsReal, props.globalIsReal);
          else
            props.updateBudgetIsReal(true, true);
        }
      }
    }
  };

  onCellChange = (id, field, value, index) => {
    let items = this.state.items;
    items[index].amount = parseInt(value);
    this.setState({ items }, () => {
      this.props.updateBudgetItemTable(items);
    });
  };

  getfontColor = (row) => {
    let color = "inherit";

    if (row && row.original) {
      const rowYear = row.original.year;
      const rowMonth = row.original.month;
      const momentYear = moment().year();
      const momentMonth = moment().month() + 1;

      if (rowYear < momentYear) {
        color = "DarkGrey";
      }
      else if (rowYear === momentYear) {
        if (rowMonth < momentMonth) {
          color = "DarkGrey";
        }
      }
    }
    return color;
  }

  getBorderInfo = (row) => {
    const info = {
      color: "#E3E3E3",
      width: "1px"
    };
    let testPast = false;

    if (this.props.globalIsReal === false)//|| this.props.budgetType !== "Client")
      return info;

    if (row && row.original) {
      const rowYear = row.original.year;
      const rowMonth = row.original.month;
      const momentYear = moment().year();
      const momentMonth = moment().month() + 1;

      if (rowYear < momentYear) {
        testPast = true;
      }
      else if (rowYear === momentYear) {
        if (rowMonth < momentMonth) {
          testPast = true;
        }
      }
      if (testPast) { // grayed...
        const date0 = new Date(momentYear, momentMonth - 1, 1);
        let dateTmp = new Date(row.original.year, row.original.month - 1, 1);
        const date1 = new Date(dateTmp.setMonth(dateTmp.getMonth() + 1));

        if (
          row.original.realValue !== 0 ||
          date1.getTime() < date0.getTime()
        ) {
          if (row.original.realValue !== row.original.amount) {
            info.color = "DarkOrange";
            info.width = "2px";
          }
        }
      }
    }
    return info;
  }

  render = () => {
    const { idsCopyRight, idsCopyDown, idsPropagateToBottom } = this.state;

    const mapRealTotal = new Map();
    const mapRealTotalMonth = new Map();
    const mapBudgetTotal = new Map();

    // let yearCurrent = 0;
    // let yearNext = 0;

    // console.log("this.state.items=", this.state.items);

    this.state.items.forEach(o => {
      let value = mapRealTotal.get(o.year);
      if (isNaN(value))
        value = 0.0;

      mapRealTotal.set(o.year, value + o.realValue);

      let budget = mapBudgetTotal.get(o.year);
      if (isNaN(budget))
        budget = 0.0;
      mapBudgetTotal.set(o.year, budget + o.amount);

      const key = "Y" + o.year + "_M" + o.month;
      let valueMonth = mapRealTotalMonth.get(key);
      if (isNaN(valueMonth))
        valueMonth = 0.0;

      mapRealTotalMonth.set(key, valueMonth + o.realValue);
    });


    // console.log("mapRealTotal=", mapRealTotal);
    // console.log("mapRealTotalMonth=", mapRealTotalMonth);
    // console.log("mapBudgetTotal=", mapBudgetTotal);

    return (
      <Table
        fixHeight={true}
        defaultPageSize={24}
        key={this.state.id}
        tableName="budgetForm"
        visibleColumns={[
          {
            name: "month", //this.props.year,
            // noTranslateColumnName: true,
            accessor: "month",
            type: "string",
            width: 100,
            Cell: row => {
              let monthAmount = 0.0;
              for (let i = 1; i <= row.original.month; i++) {
                const key = "Y" + row.original.year + "_M" + i;
                let totalMonth = mapRealTotalMonth.get(key);
                if (isNaN(totalMonth))
                  totalMonth = 0.0;
                monthAmount = monthAmount + totalMonth
              }

              const text =
                this.props.intl.formatMessage({
                  id: "ids_real"
                }) + " " +
                row.original.year + " : " +
                currencyText(
                  null,
                  mapRealTotal.get(row.original.year),
                  this.props.intl.locale,
                  0) + "\r\n(" +
                this.props.intl.formatMessage({
                  id: "ids_average"
                }) + " : " +
                currencyText(
                  null,
                  row.original.month !== 0 ? monthAmount / row.original.month : 0.0,
                  this.props.intl.locale,
                  0) +
                ")\r\n" +
                this.props.intl.formatMessage({
                  id: "ids_budget"
                }) + " " +
                row.original.year + " : " +
                currencyText(
                  null,
                  mapBudgetTotal.get(row.original.year),
                  this.props.intl.locale,
                  0);

              const fontColor = this.getfontColor(row);

              return (
                <div style={{ color: fontColor }} title={text}>
                  {row.original.monthText}
                  &ensp;
                  <i className="fa fa-info-circle text-primary"></i>
                </div>
              )
            }
          },
          {
            name: "real",
            accessor: "realValue",
            width: 100,
            Cell: row => {
              const fontColor = this.getfontColor(row);

              return (
                <div className="budgetInput">
                  <CurrencyInput
                    disabled={true}
                    style={{ color: fontColor }}
                    digit={0}
                    value={row.original.realValue}
                    currencyId={this.props.currencyId}
                    update={e => {
                      // console.log("budgetInput.update()", e.value);
                      // let items = this.state.items;
                      // items[row.index].amount = e.value;
                      // this.setState({ items }, () => {
                      //   this.props.updateBudgetItemTable(items);
                      // });
                      // return onChange(
                      //   { ...taxPiece, amount: event.value },
                      //   index,
                      //   lineIndex
                      // );
                    }}
                  />
                </div>
              );

              // Cell: row => {
              //   return row.original.realValue;
              // }
            }
          },
          {
            name: " ",
            noTranslateColumnName: true,
            width: 40,
            type: "string",
            Cell: row => {
              return (
                <div
                  style={{ width: "100%" }}
                  onClick={e => {
                    let items = this.state.items;
                    items[row.index].amount = items[row.index].realValue;

                    this.setState({ items }, () => {
                      this.props.updateBudgetItemTable(items);
                    });
                  }}
                  className="text-primary fa fa-arrow-circle-right"
                  title={idsCopyRight}
                />
              );
            }
          },
          {
            name: "budget",
            accessor: "amount",
            textAlign: "right",
            type: "string",
            width: 100,
            Cell: row => {
              const fontColor = this.getfontColor(row);
              const borderInfo = this.getBorderInfo(row);

              return (
                <div className="budgetInput">
                  <CurrencyInput
                    style={{
                      color: fontColor,
                      borderColor: borderInfo.color,
                      borderWidth: borderInfo.width
                    }}
                    digit={0}
                    value={row.value}
                    currencyId={this.props.currencyId}
                    update={e => {
                      console.log("budgetInput.update()", e.value);

                      let items = this.state.items;
                      items[row.index].amount = e.value;
                      this.setState({ items }, () => {
                        this.props.updateBudgetItemTable(items);
                      });

                      // return onChange(
                      //   { ...taxPiece, amount: event.value },
                      //   index,
                      //   lineIndex
                      // );
                    }}
                  />
                </div>
              );
            }

            // FOOTER disabled to make place for 24 months
            // Footer: (
            //   <strong>
            //     {
            //       <CurrencySpan
            //         value={_.sumBy(this.state.items, "amount")}
            //         currencyId={this.props.currencyId}
            //         digit={0}
            //       />
            //     }
            //   </strong>
            // ),
            // type: "edit",
          },
          {
            name: " ",
            noTranslateColumnName: true,
            width: 80,
            type: "string",
            Cell: row => {
              return (
                <React.Fragment>
                  <div
                    style={{ width: "50%" }}
                    onClick={() => {
                      let items = this.state.items;
                      if (row.index + 1 < items.length) {
                        items[row.index + 1].amount = items[row.index].amount;
                      }

                      this.setState({ items }, () => {
                        this.props.updateBudgetItemTable(items);
                      });
                    }}
                    className="text-primary fa fa-arrow-circle-down"
                    title={idsCopyDown}
                  />
                  <img
                    title={idsPropagateToBottom}
                    alt=""
                    src={toBottomRound}
                    onClick={() => {
                      let items = this.state.items;
                      for (let i = row.index; i < items.length; i++) {
                        items[i].amount = items[row.index].amount;
                      }

                      this.setState({ items }, () => {
                        this.props.updateBudgetItemTable(items);
                      });
                    }}
                  />
                  {/* <div
                    style={{ width: "50%" }}
                    className="text-success fa fa-arrow-circle-right"
                  /> */}
                </React.Fragment>
              );
            }
          },
          {
            name: "updatedBy",
            accessor: "tiersCollaborator.name",
            // maxWidth: 160
            type: "string",
            Cell: row => {
              const fontColor = this.getfontColor(row);
              return (
                <div style={{ color: fontColor }}>
                  {row.original && row.original.tiersCollaborator && row.original.tiersCollaborator.name || ""}
                </div>
              )
            }
          },
          {
            name: "on",
            type: "date",
            accessor: "dateSaisie",
            maxWidth: 130,
            Cell: row => {
              const fontColor = this.getfontColor(row);
              return (
                <div style={{ color: fontColor }}>
                  {/* {row.original.dateSaisie} */}
                  {row.value
                    ? moment(row.original.dateSaisie).format(
                      row.column.dateFormat ? row.column.dateFormat : "L"
                    )
                    : ""}
                </div>
              )
            }
          }
        ]}
        data={this.state.items}
        onRowClick={id => { }}
        onRowSelect={id => { }}
        onCellChange={this.onCellChange}
        showPagination={false}
        filterable={false}
        exportable={false}
        // defaultSorted={[{ id: "monthText", desc: false }]}
        showFilter={false}
      />
    );
  };
}

export default compose(
  injectIntl
  // graphql(Queries.getBudgetItemsByYear, {
  //   name: "getBudgetItemsByYear"
  // })
)(BudgetItemFormTable);
